import { FC } from 'react';

import { FiCheckCircle, FiCircle } from 'react-icons/fi';
import { IconType } from 'react-icons';

import { Tooltip } from '~/shared/components/Tooltip';

import {
  Container,
  IconWrapper,
  Content,
  RightElementContainer,
} from './styles';

export interface ICustomRadioProps {
  onClick?(): Promise<void> | void;
  title: string;
  description?: string;
  icon?: IconType;
  tooltip?: string;
  checked?: boolean;
  hasError?: boolean;
  customEndIcon?: IconType;
}

export const CustomRadio: FC<ICustomRadioProps> = ({
  onClick,
  tooltip,
  title,
  description,
  icon: Icon,
  checked = false,
  hasError = false,
  customEndIcon: CustomEndIcon,
}) => {
  return (
    <Container checked={checked} hasError={hasError}>
      <Tooltip label={tooltip}>
        <button type="button" onClick={onClick}>
          {!!Icon && (
            <IconWrapper>
              <Icon />
            </IconWrapper>
          )}

          <Content>
            <div>
              <strong>{title}</strong>

              {!!description && <p>{description}</p>}
            </div>
          </Content>

          <RightElementContainer checked={checked} hasError={hasError}>
            {CustomEndIcon ? (
              <CustomEndIcon />
            ) : checked ? (
              <FiCheckCircle />
            ) : (
              <FiCircle />
            )}
          </RightElementContainer>
        </button>
      </Tooltip>
    </Container>
  );
};
